<template>
	<div class="mt-10 flex items-center justify-center">
		<img
			:src="Party"
			class="w-[372px]"
		/>
	</div>
</template>

<script setup>
const Party = '/img/party.png';
</script>